module.exports = __webpack_public_path__ + "landlord_logo.4045b877.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/LiveChat/logos/landlord_logo.png
// module id = 2074
// module chunks = 0